import { type UseQueryResult, useQuery } from 'react-query';
import {
  FeatureSetService,
  PagedResultDto_FeatureSetResponseDto,
} from '@wealthlane/api-services/wealthlane-identity-service';
import { TableParamsType } from '../../types/common';

const useGetVendorFeatureSet = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filterCustomValue?: string[]
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_FeatureSetResponseDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const vendorFeatureSet = useQuery(
    ['getVendorFeatureSet', filter, filterCustomValue, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        FeatureSetService.getApiIdentityFeatureSet(
          filter,
          filterCustomValue ?? [],
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return vendorFeatureSet;
};

export default useGetVendorFeatureSet;
